import { render } from "./FooterGlobal.vue?vue&type=template&id=cefeb8e4"
import script from "./FooterGlobal.vue?vue&type=script&lang=js"
export * from "./FooterGlobal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__